import { render, staticRenderFns } from "./LuckyWheel.vue?vue&type=template&id=2ccf9916&scoped=true"
import script from "./LuckyWheel.vue?vue&type=script&lang=js"
export * from "./LuckyWheel.vue?vue&type=script&lang=js"
import style0 from "./LuckyWheel.vue?vue&type=style&index=0&id=2ccf9916&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ccf9916",
  null
  
)

export default component.exports